module.exports = __webpack_public_path__ + "img/Croatia.9e2bf281.png";